<template>
  <div class="panel">
    <div class="content">
      <div class="title-container">
        <div v-if="!editName" class="editable title" @click="editName = true">
          {{ sectionName }}<Pen class="edit-icon" />
        </div>
        <div v-else class="title-edit">
          <FireInput
            ref="sectionName-field"
            class="text-input"
            :value="sectionName"
            @change="value => (sectionName = value)"
          />
          <div class="cancel" @click.stop="undoSectionName">
            <Cross class="icon" />
          </div>
          <div class="validate" @click.stop="changeSectionName">
            <Check class="icon" />
          </div>
        </div>
        <InfoBubbleIcon class="icon info-bubble-anchor" @click="togglePopup" />
        <HelpBubble :content="sectionsInfos" :visible="showPopup" @on-click="closePopup" />
      </div>
      <div class="divider"></div>
      <div ref="sortable" class="container">
        <div v-for="item in sortedItems" :key="item.id" class="section" :data-id="item.id">
          <div class="handle"><SlideIcon /></div>
          <Skill ref="skillsItem" :item="item" />
          <div class="secondary-button inverted" @click.stop="removeItem(item)">
            <BinIcon class="icon" />{{ $t('editor.skills.delete') }}
          </div>
        </div>
      </div>
      <div class="secondary-button" @click="addItem()"><AddIcon class="icon" />{{ $t('editor.skills.add') }}</div>
    </div>
    <div ref="resize-handle" class="resize">
      <div class="line" />
      <div class="line" />
      <div class="line" />
    </div>
  </div>
</template>

<script>
import { Sortable } from '@shopify/draggable';
import PanelMixin from '../mixins/PanelMixin';
import AddIcon from '@/assets/listing/add.svg';
import BinIcon from '@/assets/listing/bin.svg';
import SlideIcon from '@/assets/listing/slide.svg';
import Skill from './Skill';
import HelpBubble from '@/components/HelpBubble.vue';
import InfoBubbleIcon from '@/assets/icons/infobulle.svg';
import InfoBubbleMixin from '@/components/panels/mixins/InfoBubbleMixin.vue';
import sectionInfosData from '@/helpers/SectionHelp.js';

export default {
  name: 'SkillPanel',
  components: {
    InfoBubbleIcon,
    HelpBubble,
    Skill,
    AddIcon,
    BinIcon,
    SlideIcon,
  },
  mixins: [PanelMixin, InfoBubbleMixin],

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    scrollTo: {
      type: Function,
      required: true,
    },
  },

  emits: ['deleteItem'],

  data() {
    return {
      sectionId: 'skills',
    };
  },
  computed: {
    sortedItems() {
      if (!this.items.length) return [];
      const itemsCloned = JSON.parse(JSON.stringify(this.items));
      return itemsCloned.sort((a, b) => a.order - b.order);
    },
    sectionsInfos() {
      return sectionInfosData[this.sectionId];
    },
  },

  mounted() {
    this.scrollTo();

    this.checkIfMustOpenPopup(this.sectionId);

    const sortable = new Sortable(this.$refs.sortable, {
      draggable: '.section',
      handle: '.handle',
    });
    sortable.on('sortable:stop', e => {
      if (e.newIndex === e.oldIndex) return;
      const itemId = e.dragEvent.source.dataset.id;
      const items = this.sortedItems.filter(i => i.id !== itemId);
      items.splice(
        e.newIndex,
        0,
        this.items.find(i => i.id === itemId)
      );
      items.forEach((i, index) => {
        i.order = index;
        this.$store.dispatch('items.edit', { id: i.id, order: index });
      });
    });
  },
  methods: {
    updateFields() {
      this.$refs.skillsItem.forEach(component => component.updateFields());
    },
    removeItem(item) {
      this.$emit('deleteItem', item);
    },
    addItem() {
      this.$store.dispatch('items.create', {
        resumeId: this.$route.params.id,
        item: { content: {}, order: this.items.length, type: 'skills' },
      });
    },
  },
};
</script>
<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/inspector.scss';

.panel {
  .title {
    text-transform: uppercase;
  }
  .section {
    outline: none;
    position: relative;
    padding-right: 12px;
    &.draggable-mirror {
      background-color: #f2f2f2;
      width: 316px;
      cursor: grabbing;
    }
    .handle {
      position: absolute;
      right: 5px;
      top: -5px;
      height: 30px;
      width: 30px;
      cursor: grab;
    }
    &::after {
      content: '';
      width: 100%;
      margin: 16px 24px 16px auto;
      height: 1px;
      background: colors.$grey-background-color;
    }
    .seconday-button {
      margin: 0 auto;
    }
  }
  .container {
    padding-right: 10px;
    outline: none;
  }
}

.title-container {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .icon {
    cursor: pointer;
    height: 24px;
    margin-right: 8px;
    margin-left: 8px;
    transition-duration: 0.1s;

    &:hover {
      scale: 1.1;
    }

    &:active {
      scale: 0.9;
    }
  }
}
</style>
